// extracted by mini-css-extract-plugin
export default {"process":"Process_process__Qryoo","Cards":"Process_Cards__+arj-","card":"Process_card__EW08M"};